import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import PublisherList from "./PublisherList";
import PublisherDetailPage from "./PublisherDetailPage";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
export var Publishers = function () {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/detail"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                    RoleEnum.COLLECTIONS_ADMINISTRATOR,
                ] },
                React.createElement(PublisherDetailPage, null))); } })));
};
